const buttonScrollToTop = $(".footer__btn-scroll-top");

function scrollToTop() {
  $("html, body").animate({ scrollTop: 0 });
}

// Add Listeners
buttonScrollToTop.on("click", scrollToTop);
